import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { ThreatProfile } from '@cyborg-monorepo/hunter/common';
import Mark from 'mark.js';
import { gatherTags } from '../../../../helpers/utils';
import { SearchStateService } from '../../../research/services/search-state.service';
import { FavoriteService } from '../../services/favorite.service';
import { FacetButtonItem } from '../facet-buttons/facet-buttons.component';

@Component({ standalone: false, 
  selector: 'threat-profiles',
  styleUrls: ['./threat-profiles.component.scss'],
  templateUrl: './threat-profiles.component.html',
})
export class ThreatProfileComponent implements OnInit, AfterViewInit {
  @Input() public data: ThreatProfile;
  public favorited: boolean;
  public tags: FacetButtonItem[];

  constructor(
    private myElement: ElementRef,
    private searchStateService: SearchStateService,
    private favoriteService: FavoriteService
  ) {}

  public ngOnInit(): void {
    this.isFavorited();
    this.tags = gatherTags(this.data);
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.textHightlighting();
    }, 0);
  }

  private isFavorited(): void {
    this.favoriteService
      .checkThreatProfileFavorite(this.data.UUID)
      .subscribe((favorite: boolean) => {
        this.favorited = favorite;
      });
  }

  public favorite(): void {
    this.favoriteService.favoriteThreatProfile(this.data.UUID).subscribe(() => {
      this.favorited = true;
      this.favoriteService.setUpdated(true);
    });
  }
  public unfavorite(): void {
    this.favoriteService
      .unfavoriteThreatProfile(this.data.UUID)
      .subscribe(() => {
        this.favorited = false;
        this.favoriteService.setUpdated(true);
      });
  }

  private textHightlighting(): void {
    const context =
      this.myElement.nativeElement.querySelectorAll('p, header-title');
    const instance = new Mark(context);
    const term = this.searchStateService.state.value.term;
    if (term) {
      instance.mark(term, {
        element: 'em',
        className: 'highlight',
      });
    }
  }
}
